import { ContactUsPageContent } from "@app/contact-us/pages";
import { pageHead } from "@framework/config/drivers";
import { trans } from "@mongez/localization";

export default function ContactUs() {
  return <ContactUsPageContent />;
}

export function meta() {
  return pageHead({
    title: trans("contactUs"),
    appendAppName: true,
  });
}
